/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-depot-discount-groups-management-component",
	props: ["companyId", "activeOrInactiveKey", "searchQuery", "filterStateChanged", "showLinkingModal", "showTableActions", "companyName"],
	emits: ["linkingModalClose"],
	data() {
		return {
			depotDiscountGroups: [],
			depotDiscountGroupsHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Depot",
					field: "depot"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
            productsToLinkHeadings:[
                {
                    text: "Product",
                    field: "name"
                },
                // {
                // 	text: "Original Price",
                // 	field: "priceAsString"
                // },
                {
                    text: "Discount Amount",
                    field: "discountAmountAsString"
                },
                // {
                // 	text: "Price After Discount",
                // 	field: "priceAfterDiscountAsString"
                // }
            ],
			depots: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				view: "view",
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				linkProducts: "linkProducts",
				linkCustomers: "linkCustomers"
			},
			initialiseDate: true,
			customerDiscountUnlinkCustomerModal:{
				showModal: false,
				isSaving: false,
				modalId: "unlinkCustomerDiscountGroupModal",
				heading: "Unlink Customer From Depot Discount Group?",
				message: "Unlinking a customer from a depot discount group will remove the customer's discount. Are you sure you want to unlink this customer?",
				customerDiscountGroupId: null
			},
			customerDiscountGroupAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditCustomerDiscountGroupModal",
				heading: "Add Customer Discount Group",
				customerDiscountGroup:{
					customerDiscountGroupId: null,
					isActive: true,
					depotId:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountAmount: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: new Date(),
						hasError: false,
						errorMessage: null
					}
				}
			},
			linkAndUnlinkDiscountGroupModal:{
				showModal: false,
				isSaving: false,
				modalId: "linkAndUnlinkDepotDiscountGroupModal",
				heading: "Link And Unlink Discount Group From Customer",
				isActive: null,
				companyId: null
			},
			customerDiscountGroupMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markCustomerDiscountGroupAsActiveInactiveModal",
				heading: "Mark Customer Discount Group As Active/Inactive",
				isActive: null,
				customerDiscountGroupId: null
			},
			linkProductsToDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToDiscountGroupModal",
				heading: "Link Products To Discount Group",
				customerDiscountGroupId: null,
				depotId: null
			},
            customerDiscountGroupAddEditForm:{
                customerDiscountGroup:{
                    customerDiscountGroupId: null,
                    isActive: true,
                    depotId:{
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    name: {
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    discountAmount: {
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    effectiveDate: {
                        value: new Date(),
                        hasError: false,
                        errorMessage: null
                    },
                    linkedProducts:{
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                    unlinkedProducts:{
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                    linkedCustomers: {
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                    unlinkedCustomers: {
                        value: [],
                        hasError: false,
                        errorMessage: null
                    }
                }
            },
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				depotId: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			tableHasActions: true
		};
	},
	methods: {
		getDepotDiscountGroups(){
			this.loading = true;
			let request ={
				searchQuery: this.searchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				depotId: this.filter.depotId === null ? 0 : this.filter.depotId,
				//companyId: this.companyId
			};
			orderService.getDepotDiscountGroups(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depotDiscountGroups = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.depotDiscountGroups.length; i++) {
							this.depotDiscountGroups[i].actions = [
								{
									name: "View",
									key: this.actionKeys.view,
									elementId: "btnViewCustomerDiscountGroup"
								}
							];
							this.depotDiscountGroups[i].discountAmountAsString = currencyHelper.numberToCurrency(this.depotDiscountGroups[i].discountAmount);
						}
						this.depotDiscountGroups = dataTableHelper.castFieldValues(this.depotDiscountGroups);
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepots(){
			this.loading = true;
			let request = {
				isActive: true,
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = $.map(this.depots,
							function (obj) {
								obj.id = obj.id || obj.depotId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.depots.unshift({
							depotId: 0,
							id: 0,
							text: "All"
						});
						this.depots = dataTableHelper.castFieldValues(this.depots);
						this.filter.depotId = this.depots[0].depotId;
						this.getDepotDiscountGroups();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
        getProductsForDepotDiscountGroup(){
            orderService.getProductsForDepotDiscountGroup(this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId).then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value = successResponse.data.result;
                        for(let i = 0; i < this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.length; i++){
                            this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmount);
                        }
                    }
                },
                errorResponse => {
                    console.log("error", errorResponse);
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
		// onDepotFilterSelect(depot){
		// 	if(this.filter.depotId !== depot.id){
		// 		this.filterStateChanged = true;
		// 	}
		// 	this.filter.depotId = depot.id;
		// 	//this.getDepotProducts();
		// },
		onFilterSearchClicked(){
			this.getDepotDiscountGroups();
		},
		// onActiveInactiveFilterSelected(activeOrInactiveKey){
		// 	this.filter.activeOrInactiveItems = activeOrInactiveKey;
		// 	this.filterStateChanged = true;
		// },
		onLinkAndUnlinkClick(){
			this.linkAndUnlinkDiscountGroupModal.showModal = true;
			this.linkProductsToDiscountGroupModal.companyId = this.companyId;
		},
		onLinkUnlinkModalClose(){
			this.linkAndUnlinkDiscountGroupModal.showModal = false;
			this.$emit("linkingModalClose", true);
		},
        onCustomerDiscountGroupActionClicked(actionAndData){
            console.log("actionAndData", actionAndData);
            switch(actionAndData.action){
                case this.actionKeys.view:
                    $("#viewDiscountGroupModal").modal("show");
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId = actionAndData.data.depotDiscountGroupId;
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.value = actionAndData.data.name;
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value = actionAndData.data.discountAmount;
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.value = actionAndData.data.depotId;
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.value = actionAndData.data.effectiveDate;
                    this.getProductsForDepotDiscountGroup();
                    break;
            }
        },
        onViewDiscountGroupModalClose(){
            $("#viewDiscountGroupModal").modal("hide");
            this.clearCustomerDiscountGroupModel();
        },
		// onCustomerDiscountGroupActionClicked(actionAndData){
		// 	console.log("actionAndData", actionAndData);
		// 	switch(actionAndData.action){
		// 		case this.actionKeys.unlink:
		// 			this.customerDiscountUnlinkCustomerModal.customerDiscountGroupId = actionAndData.data.depotDiscountGroupId;
		// 			this.customerDiscountUnlinkCustomerModal.showModal = true;
		// 			break;
		// 	}
		// },
		// onConfirmUnlinkClick(confirm){
		// 	if(confirm){
		// 		this.unlinkCustomerFromDepotDiscountGroup();
		// 	}
		// 	else{
		// 		this.customerDiscountUnlinkCustomerModal.showModal = false;
		// 	}
		// },
		// unlinkCustomerFromDepotDiscountGroup(){
		// 	this.customerDiscountUnlinkCustomerModal.isSaving = true;
		// 	let request = {
		// 		depotDiscountGroupId: this.customerDiscountUnlinkCustomerModal.customerDiscountGroupId,
		// 		companyIdsToLink: [],
		// 		companyIdsToUnlink: [this.companyId]
		// 	};
		// 	orderService.linkAndUnlinkCompaniesFromDepotDiscountGroup(request).then(
		// 		successResponse => {
		// 			let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
		// 			if(isSuccess){
		// 				this.showSuccessMessage = true;
		// 				this.successMessage = "Customer unlink was successful";
		// 				this.getDepotDiscountGroups();
		// 			}
		// 			else{
		// 				this.showErrorMessage = true;
		// 				this.errorMessage = successResponse.data.message;
		// 			}
		// 			this.customerDiscountUnlinkCustomerModal.isSaving = false;
		// 			this.customerDiscountUnlinkCustomerModal.showModal = false;
		// 		},
		// 		errorResponse => {
		// 			console.log("error", errorResponse);
		// 			this.customerDiscountUnlinkCustomerModal.isSaving = false;
		// 			this.customerDiscountUnlinkCustomerModal.showModal = false;
		// 			apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
		// 		}
		// 	);
		// },
		// onLinkingSave(isSuccess){
		// 	if(isSuccess){
		// 		this.getDepotDiscountGroups();
		// 	}
		// 	else{
		// 		this.showErrorMessage = true;
		// 		this.errorMessage = "Error occurred while linking depot discount groups to customer";
		// 	}
		// 	this.linkAndUnlinkDiscountGroupModal.showModal = false;
		// 	this.$emit("linkingModalClose", true);
		// },
		clearCustomerDiscountGroupModel(){
            this.customerDiscountGroupAddEditForm = {
                customerDiscountGroup: {
                    customerDiscountGroupId: null,
                    isActive: true,
                    depotId:{
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    name: {
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    discountAmount: {
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    effectiveDate: {
                        value: new Date(),
                        hasError: false,
                        errorMessage: null
                    },
                    linkedProducts:{
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                    unlinkedProducts:{
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                    linkedCustomers: {
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                    unlinkedCustomers: {
                        value: [],
                        hasError: false,
                        errorMessage: null
                    }
                }
            };
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup = {
				customerDiscountGroupId: null,
				isActive: true,
				depotId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				name: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				effectiveDate: {
					value: new Date(),
					hasError: false,
					errorMessage: null
				}
			}
			this.initialiseDate = true;
		},
		onSuccessModalOkClick(){
			this.showSuccessMessage = false;
		},
		onErrorModalOkClick(){
			this.showErrorMessage = false;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Depot Special Pricing - " + this.companyName);
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Pricing"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Depot Special Pricing"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
		// setBreadcrumbs() {
		// 	var pageTitle = "Link Customers to Depot Discount Group - " + this.companyName;
		// 	storeState.setPageTitleAction(pageTitle);
		// 	breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		// }
	},
	mounted: function () {
		// this.setBreadcrumbs();
		this.getDepots();
	},
	watch:{
		// companyId: {
		// 	handler: function () {
		// 		if(this.companyId !== null && this.companyId > 0){
		// 			this.getDepotDiscountGroups();
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		filterStateChanged:{
			handler: function () {
				if(!this.filterStateChanged){
					// if(this.companyId !== null && this.companyId > 0){
					// 	this.getDepotDiscountGroups();
					// }
                    this.getDepotDiscountGroups();
				}
			},
			immediate: true,
			deep: true
		},
		showLinkingModal:{
			handler: function () {
				if(this.showLinkingModal){
					this.onLinkAndUnlinkClick();
				}
			},
			immediate: true,
			deep: true
		},
		showTableActions:{
			handler: function () {
				this.tableHasActions = this.showTableActions;
			},
			immediate: true,
			deep: true
		},
		companyName:{
			handler: function () {
				console.log("companyName", this.companyName);
				if(this.companyName){
					this.setBreadcrumbs();
				}
			},
			immediate: true,
			deep: true
		}
	}
};